// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"8ae6a214","239":"2e5bfb3c","453":"ad0c6247","578":"7a4c26fc","622":"919e8d57","857":"a9d9424e","977":"dab5d54a"}[chunkId] + ".chunk.js";
};